export type LeadQuality = 'excellent' | 'good' | 'fair' | 'poor';

export interface EODSubmission {
  id: string;
  user_id: string;
  date: string;
  demos_booked: number;
  demos_showed: number;
  demos_closed: number;
  revenue_closed?: number;
  show_rate: number;
  lead_quality: LeadQuality;
  lead_quality_issues?: string;
  issues: string;
  notes: string;
  tomorrow_focus: string;
  submitted_at: string;
  submitted_late?: boolean;
}

export interface EODFormData {
  demos_booked: string;
  demos_showed: string;
  demos_closed: string;
  revenue_closed: string;
  lead_quality: LeadQuality | '';
  lead_quality_issues: string;
  issues: string;
  notes: string;
  tomorrow_focus: string;
}

export const LEAD_QUALITY_OPTIONS = [
  { value: 'excellent', label: 'Excellent (90%+ qualified)', emoji: '🟢' },
  { value: 'good', label: 'Good (70-89% qualified)', emoji: '🟡' },
  { value: 'fair', label: 'Fair (50-69% qualified)', emoji: '🟠' },
  { value: 'poor', label: 'Poor (<50% qualified)', emoji: '🔴' },
] as const;
